import { useId } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = {
  color?: Color;
  size?: Unit;
};

export const InSeason2026 = ({ size = 2, color }: Props) => {
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 51 32"
      style={{ height: unitMapping[size] }}
    >
      <linearGradient
        id={id}
        gradientUnits="userSpaceOnUse"
        x1="-0.4229"
        y1="14.3909"
        x2="51.4242"
        y2="17.6092"
      >
        <stop offset="0" style={{ stopColor: '#F8D3DA' }} />
        <stop offset="0.2832" style={{ stopColor: '#B3A9F4' }} />
        <stop offset="0.5401" style={{ stopColor: '#FBE9FB' }} />
        <stop offset="1" style={{ stopColor: '#4F94FD' }} />
      </linearGradient>
      <path
        d="M36.7,15.7h-5.9v9.9h5.9V15.7z M8.1,0L0,7.6V32h41.6l9.4-7.5V0H8.1L8.1,0z M23.2,14.1L14,20.7v4.8h9.2v2.8H10.4
   v-9l9.2-6.5v-7H14v5.6h-3.6V7.5c0-3.2,1.8-4.7,6.4-4.7s6.4,1.5,6.4,4.7L23.2,14.1L23.2,14.1z M40.3,10.8h-3.6V5.6h-5.9v8.9
   c1-1.1,2.7-1.7,4.7-1.7c2.9,0,4.8,1.4,4.8,4.4v6.4c0,3.2-1.9,4.7-6.6,4.7c-4.7,0-6.6-1.5-6.6-4.7V7.4c0-3.2,2-4.7,6.6-4.7
   s6.6,1.5,6.6,4.7L40.3,10.8L40.3,10.8z"
        fill={color || `url(#${id})`}
      />
    </svg>
  );
};
